import React from 'react';
import { createIcon } from '../../../utils/createIcon';

const IconFile = createIcon({
  viewBox: '0 0 64 64',
  path: (
    <svg
      width="64"
      height="65"
      viewBox="0 0 64 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.4442 3.34448H34.8643C36.4827 3.34448 38.0289 4.01161 39.1358 5.18746L52.2848 19.1556C53.3022 20.2364 53.8684 21.6623 53.8684 23.1437V55.8245C53.8684 59.0449 51.4108 61.6556 48.3792 61.6556H15.4442C12.4127 61.6556 9.95508 59.0449 9.95508 55.8245V9.17559C9.95508 5.95516 12.4127 3.34448 15.4442 3.34448Z"
        fill="#E6ECF5"
      />
      <mask
        id="mask0_1238_159499"
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="9"
        y="3"
        width="45"
        height="59"
      >
        <path
          d="M15.4442 3.34448H34.8643C36.4827 3.34448 38.0289 4.01161 39.1358 5.18746L52.2848 19.1556C53.3022 20.2364 53.8684 21.6623 53.8684 23.1437V55.8245C53.8684 59.0449 51.4108 61.6556 48.3792 61.6556H15.4442C12.4127 61.6556 9.95508 59.0449 9.95508 55.8245V9.17559C9.95508 5.95516 12.4127 3.34448 15.4442 3.34448Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_1238_159499)">
        <path
          d="M35.5713 0.624512V23.0245H55.838C55.4139 22.1176 54.8564 21.2743 54.1777 20.527L37.7112 2.39583C37.0766 1.69708 36.3549 1.10289 35.5713 0.624512Z"
          fill="#0D47A1"
        />
      </g>
      <path
        d="M31.8853 9.17554H19.8357C16.602 9.17554 15.4443 10.3284 15.4443 13.5489V51.4511C15.4443 54.6715 16.602 55.8244 19.8357 55.8244H43.988C47.2217 55.8244 48.3793 54.6715 48.3793 51.4511V27.3978H33.3756C32.163 27.3978 31.1799 26.4188 31.1799 25.2111V9.17554H31.8853Z"
        fill="#E6ECF5"
      />
    </svg>
  ),
});

export default IconFile;
